import { Component, OnInit } from "@angular/core";
import { Input } from "@angular/core";

@Component({
    selector: "dodo-cta-button-group",
    templateUrl: "./cta-button-group.component.html",
    styleUrls: ["./cta-button-group.component.scss"],
    standalone: false
})
export class CtaButtonGroupComponent implements OnInit {
	@Input() buttons;
	@Input() title;

	constructor() {}

	ngOnInit() {}
}
